import { NgFor, NgIf } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { WishlistService } from 'src/app/service/wishlist.service';
import { MobileMenuCommandsComponent } from '../mobile-menu-commands/mobile-menu-commands.component';

@Component({
  selector: 'app-mobile-mega-menu',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    DynamicModule,
    StoryblokDirective,
    RouterLink,
    MobileMenuCommandsComponent,
  ],
  templateUrl: './mobile-mega-menu.component.html',
  styleUrl: './mobile-mega-menu.component.scss',
})
export class MobileMegaMenuComponent {
  @Input() _editable!: string;
  @Input() _uid!: string;
  @Input() component!: string;

  @Input() label!: string;
  @Input() menus!: any;

  components: any;

  wishlist: any;
  _menu: any;

  constructor(private wishlistService: WishlistService) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });

    this.wishlistService.wishlistObservable.subscribe((data: any) => {
      this.wishlist = data.events;
    });
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  navigate() {
    window.location.href = 'https://shopify.com/9607794/account';
  }
}
